import {
  Card,
  Table,
  Space,
  Tag,
  Button,
  Modal,
  Checkbox,
  Form,
  Input,
  Select,
  message,
  Popconfirm,
  Image,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { saveApi, listApi, deleteApi } from "../../api/terminal";
import moment from "moment";

const TERMINAL_NAMES = [
  {
    terminal: "LBCT Portal",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/portals/logos/lbct.png",
    systemName: "lbct",
  },
  {
    terminal: "APM Termpoint",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/portals/logos/apm-api.png",
    systemName: "apm",
  },
  {
    terminal: "PIER T (TTI)",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/tti.png",
    systemName: "tti",
  },
   {
     terminal: "PCT",
     icon: "https://s3.us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/ssa_pct.png",
     systemName: "pct",
   },
   {
     terminal: "PIER A",
     icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/piera.png",
     systemName: "piera",
   },
  {
    terminal: "Emodal",
    icon: "https://truckerportal.emodal.com/assets/images/eModal-logo.svg",
    systemName: "emodal",
  },
    {
    terminal: "WBCT",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/wbct.png",
    systemName: "wbct",
  },
  {
    terminal: "APL/FMS",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/fms.png",
    systemName: "fms",
  },
  {
    terminal: "TRAPAC",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/trapac.png",
    systemName: "trapac",
  },
  {
    terminal: "YTI",
    icon: "https://s3-us-west-1.amazonaws.com/erl-cdn.bluecargo.io/terminals/logo/yti.png",
    systemName: "yti",
  },
];

export default function TerminalAccountPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataList, setDataList] = useState([]);
  const editRef = useRef({});

  useEffect(() => {
    getListData();
  }, []);

  //获取账号列表
  const getListData = async () => {
    const result = await listApi();
    // console.log("result", result);
    const _res = result?.list?.reduce((acc, item) => {
      acc[item["terminal"]] = item;
      return acc;
    }, {});
    const _result = TERMINAL_NAMES.map((item) => {
      let _item = { ...item };
      const data = _res[item["systemName"]];
      _item["username"] = data?.username;
      _item["password"] = data?.password;
      _item["status"] = data?.status;
      _item["id"] = data?.id;
      _item["updateTime"] = data?.updateTime;
      return _item;
    });
    // console.log("TERMINAL_NAMES", _result);
    setDataList(_result);
  };

  //保存码头账号
  const onFinish = async (values) => {
    // console.log("Success:", values);
    await saveApi({
      ...values,
      terminal: values["systemName"],
      status: 0,
      cookies: "",
    });
    handleCancel();
    message.success("Success");
    getListData();
  };

  //删除操作
  const handleDelte = async (record) => {
    if (record["id"]) {
      await deleteApi(record["id"]);
      message.success("Success");
      getListData();
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "TERMINAL",
      dataIndex: "terminal",
      key: "terminal",
      render: (_, { terminal, icon }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Image
            width={42}
            src={icon}
            preview={false}
            style={{ objectFit: "contain" }}
          />
          <a style={{ marginLeft: "8px" }}>{terminal?.toUpperCase()}</a>
        </div>
      ),
    },
    {
      title: "USER NAME #",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "PASSWORD",
      dataIndex: "password",
      key: "password",
    },
    {
      title: "STATUS #",
      key: "status",
      dataIndex: "status",
      render: (_, { status }) => {
        const statusColor = ["#ef9643", "green", "red"];
        const statusName = [
          "Pending",
          "Connected",
          "Username Or Password Error",
        ];
        return status !== undefined ? (
          <Tag color={statusColor[status]}>{statusName[status]}</Tag>
        ) : (
          <Tag color="#fbe5e5">
            <span style={{ color: "red" }}>Missing</span>
          </Tag>
        );
      },
    },
    {
      title: "UPDATE TIME",
      dataIndex: "updateTime",
      key: "updateTime",
      render: (updateTime) => {
        return moment.utc(updateTime).local().format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record) => {
        return (
          <Space size="middle">
            <a
              onClick={(e) => {
                e.preventDefault();
                // console.log("record", record);
                editRef.current = record;
                showModal();
              }}
            >
              Edit
            </a>
            <Popconfirm
              title="Are you sure?"
              onConfirm={() => handleDelte(record)}
            >
              <a style={{ color: "grey" }}>Delete</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <Card
        extra={
          <Button
            type="primary"
            onClick={(e) => {
              e.preventDefault();
              editRef.current = {};
              // showModal();
              getListData();
            }}
          >
            Refresh
          </Button>
        }
      >
        <Table columns={columns} dataSource={dataList} pagination={false} />
      </Card>
      <Modal
        title="Terminal Account"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose={true}
        footer={false}
      >
        <Form
          name="basic"
          labelCol={{
            span: 5,
          }}
          wrapperCol={{
            span: 18,
          }}
          initialValues={{ ...editRef.current }}
          onFinish={onFinish}
          autoComplete="off"
          style={{ paddingTop: "25px" }}
        >
          <Form.Item label="ID" name="id" style={{ display: "none" }}>
            <Input />
          </Form.Item>
          <Form.Item
            label="SystemName"
            name="systemName"
            style={{ display: "none" }}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Terminal"
            name="terminal"
            rules={[
              {
                required: true,
                message: "Please select the terminal!",
              },
            ]}
          >
            <Select disabled></Select>
          </Form.Item>

          <Form.Item
            label="Username"
            name="username"
            rules={[
              {
                required: true,
                message: "Please input your username!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 12,
            }}
          >
            <Space>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
              <Button onClick={(e) => handleCancel()}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
